export function toDateStringWithWeekday(date: string | number | Date, locale: string): string {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: '2-digit',
    year: 'numeric',
    day: '2-digit',
  };
  return new Date(date).toLocaleDateString(locale, options);
}

export function toIsoDateOnly(date: string | number | Date | null | undefined): string | undefined {
  if (!date) {
    return undefined;
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  return parsed.toISOString().split('T')[0];
}
